// START OF MPE-AEL Preset Values
export const mpe_ael_point_cw = {
    "laserOperation": "cw",
    "sourceType": "point",
    "cw": {
        "wavelength": {
            "unit": "n",
            "num": 633
        },
        "time": {
            "unit": false,
            "num": 100
        },
        "power": {
            "unit": "m",
            "num": 0.5
        },
        "beamDiameter": {
            "unit": "m",
            "num": 1
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1.5
        },
        "distance": {
            "unit": false,
            "num": 8
        }
    }
}

export const mpe_ael_point_single_pulse = {
    "laserOperation": "singlePulse",
    "sourceType": "point",
    "singlePulse": {
        "wavelength": {
            "unit": "n",
            "num": 533
        },
        "pulseDuration": {
            "unit": "m",
            "num": 100
        },
        "outputUnits": "energy",
        "beamDiameter": {
            "unit": "m",
            "num": 3.5
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1.5
        },
        "distance": {
            "unit": false,
            "num": 100
        },
        "energy": {
            "unit": "m",
            "num": 1
        }
    }
}

export const mpe_ael_point_repetitively_pulsed = {
    "laserOperation": "repetitivelyPulsed",
    "sourceType": "point",
    "repetitivelyPulsed": {
        "wavelength": {
            "unit": "n",
            "num": 633
        },
        "time": {
            "unit": false,
            "num": 1000
        },
        "beamDiameter": {
            "unit": "m",
            "num": 1
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1
        },
        "distance": {
            "unit": false,
            "num": 55
        },
        "outputUnits": "averagePower",
        "pulseDuration": {
            "unit": "m",
            "num": 100
        },
        "pulseFrequency": {
            "unit": false,
            "num": 1
        },
        "averagePower": {
            "unit": false,
            "num": 1
        }
    }
}

export const mpe_ael_extended_cw = {
    "laserOperation": "cw",
    "sourceType": "extended",
    "cw": {
        "wavelength": {
            "unit": "n",
            "num": 512
        },
        "time": {
            "unit": false,
            "num": 100
        },
        "power": {
            "unit": false,
            "num": 5
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1
        },
        "distance": {
            "unit": false,
            "num": 30
        }
    },
    "extendedSettings": {
        "sourceInput": "apparentSourceSize",
        "apparentSourceSize": {
            "unit": "m",
            "num": 25
        }
    }
}

export const mpe_ael_extended_single_pulse = {
    "laserOperation": "singlePulse",
    "sourceType": "extended",
    "extendedSettings": {
        "sourceInput": "apparentSourceSize",
        "apparentSourceSize": {
            "unit": "m",
            "num": 25
        }
    },
    "singlePulse": {
        "wavelength": {
            "unit": "n",
            "num": 633
        },
        "pulseDuration": {
            "unit": "u",
            "num": 1
        },
        "outputUnits": "energy",
        "energy": {
            "unit": "m",
            "num": 1
        },
        "beamDivergence": {
            "unit": "m",
            "num": 5
        },
        "distance": {
            "unit": false,
            "num": 5
        }
    }
}

export const mpe_ael_extended_repetitively_pulsed = {
    "laserOperation": "repetitivelyPulsed",
    "sourceType": "extended",
    "extendedSettings": {
        "sourceInput": "apparentSourceSize",
        "apparentSourceSize": {
            "unit": "m",
            "num": 25
        }
    },
    "repetitivelyPulsed": {
        "wavelength": {
            "unit": "n",
            "num": 512
        },
        "time": {
            "unit": false,
            "num": 5
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1
        },
        "distance": {
            "unit": false,
            "num": 5
        },
        "outputUnits": "averagePower",
        "pulseDuration": {
            "unit": "u",
            "num": 1
        },
        "pulseFrequency": {
            "unit": "k",
            "num": 5
        },
        "averagePower": {
            "unit": false,
            "num": 1
        }
    }
}
// END OF MPE-AEL PRESET VALUES


// START OF FIBER OPTIC PRESET VALUES
export const fiberOptic_single_mode_cw = {
    "laserOperation": "FO_cw",
    "sourceType": "singlemode",
    "FO_cw": {
        "wavelength": {
            "unit": "n",
            "num": 512
        },
        "time": {
            "num": 100
        },
        "power": {
            "unit": "m",
            "num": 1
        },
        "diameter": {
            "unit": "u",
            "num": 5
        },
        "distance": {
            "unit": false,
            "num": 5
        }
    }
}

export const fiberOptic_single_mode_singlePulse = {
    "laserOperation": "FO_singlePulse",
    "sourceType": "singlemode",
    "FO_singlePulse": {
        "wavelength": {
            "unit": "n",
            "num": 1012
        },
        "duration": {
            "unit": "m",
            "num": 1
        },
        "power": {
            "unit": "m",
            "num": 5
        },
        "diameter": {
            "unit": "u",
            "num": 5
        },
        "distance": {
            "unit": false,
            "num": 6
        }
    }
}

export const fiberOptic_single_mode_repetitively_pulsed = {
    "laserOperation": "FO_repetitivelyPulsed",
    "sourceType": "singlemode",
    "FO_repetitivelyPulsed": {
        "wavelength": {
            "unit": "n",
            "num": 633
        },
        "time": {
            "unit": false,
            "num": 5
        },
        "distance": {
            "unit": false,
            "num": 10
        },
        "outputUnits": "averagePower",
        "duration": {
            "unit": "m",
            "num": 1
        },
        "pulseFrequency": {
            "unit": "k",
            "num": 6
        },
        "diameter": {
            "unit": "u",
            "num": 5
        },
        "averagePower": {
            "unit": false,
            "num": 1
        }
    }
}
// END OF FIBER OPTIC PRESET VALUES

// START OF DIFFUSE REFLECTIVE PRESET VALUES
export const diffuseReflective_cw = {
    "laserOperation": "diffuseReflectiveCW",
    "sourceType": "point",
    "diffuseReflective": {
        "albedo": {
            "num": 5
        },
        "distance2": {
            "unit": false,
            "num": 5
        }
    },
    "diffuseReflectiveCW": {
        "wavelength": {
            "unit": "n",
            "num": 900
        },
        "time": {
            "unit": false,
            "num": 100
        },
        "power": {
            "unit": false,
            "num": 5
        },
        "beamDiameter": {
            "num": 5
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1
        },
        "distance": {
            "unit": false,
            "num": 5
        }
    }
}

export const diffuseReflective_single_pulse = {
    "laserOperation": "diffuseReflectiveSinglePulse",
    "sourceType": "point",
    "diffuseReflective": {
        "albedo": {
            "num": 5
        },
        "distance2": {
            "unit": false,
            "num": 10
        }
    },
    "diffuseReflectiveSP": {
        "wavelength": {
            "unit": "n",
            "num": 633
        },
        "pulseDuration": {
            "unit": "u",
            "num": 1
        },
        "beamOutputUnit": "energy",
        "energy": {
            "unit": "m",
            "num": 1
        },
        "beamDiameter": {
            "num": 5
        },
        "beamDivergence": {
            "unit": "m",
            "num": 5
        },
        "distance": {
            "unit": false,
            "num": 5
        }
    }
}

export const diffuseReflective_repetitively_pulsed = {
    "laserOperation": "diffuseReflectiveRepetitivelyPulsed",
    "sourceType": "point",
    "diffuseReflective": {
        "albedo": {
            "num": 5
        },
        "distance2": {
            "unit": false,
            "num": 30
        }
    },
    "diffuseReflectiveRP": {
        "wavelength": {
            "unit": "n",
            "num": 512
        },
        "time": {
            "unit": false,
            "num": 100
        },
        "beamDiameter": {
            "num": 5
        },
        "beamDivergence": {
            "unit": "m",
            "num": 1
        },
        "distance": {
            "unit": false,
            "num": 15
        },
        "beamOutputUnit": "averagePower",
        "pulseDuration": {
            "unit": "u",
            "num": 5
        },
        "pulseFrequency": {
            "unit": "k",
            "num": 1
        },
        "averagePower": {
            "unit": "k",
            "num": 1
        }
    }
}

export const lookupTableValues = {
    "lookupTable": {
        "sourceType": "point",
        "wavelength": {
            "unit": "n",
            "num": 512
        },
        "time": {
            "unit": false,
            "num": 50
        },
        "source": {
            "parameter": "sizeDistance",
            "sourceSize": {
                "unit": "m",
                "num": 1
            },
            "distance": {
                "unit": false,
                "num": 1
            }
        }
    }
}
